import { useRef, useState } from "react";
import { Play, Clapperboard } from "lucide-react";
import { H2 } from "@/components/landing/Kit";

export function ExplainerVideo() {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const start = () => { setPlaying(true); ref.current?.play().catch(() => {}); };
  return (
    <section id="video" className="max-w-6xl mx-auto px-5 sm:px-8 py-10 sm:py-14" data-testid="landing-video">
      <div className="max-w-2xl mb-8 sm:mb-10 fade-up">
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-rose-100 text-rose-600 text-xs font-extrabold uppercase tracking-widest"><Clapperboard className="w-3.5 h-3.5" /> In 70 Sekunden erklärt</span>
        <h2 className={`${H2} mt-4`}>Das ist <span className="text-transparent bg-clip-text bg-gradient-to-r from-rose-500 to-fuchsia-500">itzPlay</span></h2>
        <p className="text-slate-600 mt-3 text-base">Videos schauen, Punkte sammeln, mitspielen und Geschenke gewinnen – schau dir an, was dich in unserer Community erwartet.</p>
      </div>
      <div className="relative rounded-[2rem] p-2 sm:p-3 bg-gradient-to-br from-rose-400 via-pink-400 to-fuchsia-500 shadow-2xl shadow-rose-200/70 fade-up">
        <div className="relative rounded-[1.6rem] overflow-hidden bg-rose-100 aspect-video">
          <video ref={ref} src="/itzcouple-erklaervideo.mp4?v=2" poster="/itzcouple-erklaervideo.jpg?v=2" preload="none" playsInline controls={playing}
            onPause={(e) => e.currentTarget.ended && setPlaying(false)} onEnded={() => setPlaying(false)} className="w-full h-full object-cover" data-testid="landing-video-player" />
          {!playing && (
            <button onClick={start} data-testid="landing-video-play" aria-label="Erklärvideo abspielen" className="group absolute inset-0 flex items-center justify-center bg-black/10 hover:bg-black/5 transition-colors">
              <span className="relative w-20 h-20 sm:w-28 sm:h-28 rounded-full bg-white text-rose-500 flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform duration-300">
                <span className="absolute inset-0 rounded-full ring-8 ring-white/50 animate-ping" style={{ animationDuration: "2.2s" }} />
                <Play className="w-8 h-8 sm:w-11 sm:h-11 ml-1 fill-current" />
              </span>
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
